<div
  class="max-w-3xl w-full bg-white shadow-lg rounded-lg overflow-hidden py-6 sm:py-10 justify-center m-auto"
>
  <!-- Purple Header Section -->
  <div class="bg-purple-600 text-white text-center p-5 sm:p-8 relative">
    <!-- Checkmark Icon -->
    <div
      class="absolute left-1/2 transform -translate-x-1/2 -top-10 bg-white rounded-full w-20 h-20 flex items-center justify-center border-4 border-white shadow-md"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-10 w-10 text-purple-600"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M5 13l4 4L19 7"
        />
      </svg>
    </div>

    <!-- Thank You Text -->
    <!-- <h2 class="text-3xl font-bold mt-8">Thank You!</h2>
      <p class="text-lg mt-2">Your order has been successfully placed.</p> -->
    <!-- Gift Icon -->
    <!-- <div class="mt-8">
  <img 
  
  ="assets/images/reward-gift.png"
       alt="Reward Gift"
       class="mx-auto"
       style="width:120px;">
</div> -->
    <!-- No Reward -->
    <div *ngIf="!ordesDeails?.coupon_amount || ordesDeails?.coupon_amount == 0">
      <h2 class="text-3xl font-bold mt-8">Thank You!</h2>

      <p class="text-lg mt-2">Your order has been successfully placed.</p>
    </div>

    <div *ngIf="ordesDeails?.coupon_amount > 0">
      <h2 class="text-3xl font-bold mt-3 text-white">Congratulations!</h2>
      <div class="mt-4">
        <i class="fas fa-gift text-warning" style="font-size: 90px"></i>
      </div>
      <!-- <i class="bi bi-gift-fill text-warning" style="font-size:90px;"></i> -->
      <h2 class="text-3xl font-bold mt-3 text-white">You Won</h2>

      <h3 class="text-5xl fw-bold text-warning mt-2">
        ₹{{ ordesDeails.coupon_amount }}
      </h3>

      <p class="text-lg mt-2 text-white">Added to your Rewards Wallet</p>
    </div>
  </div>

  <!-- Order Details Section -->
  <div class="p-4 sm:p-6 space-y-6">
    <!-- Order Summary -->
    <div class="grid grid-cols-2 gap-4 border-b pb-4">
      <div class="text-gray-500">Order Number</div>
      <div class="min-w-0 break-all font-semibold text-gray-800">#{{ ordesDeails?._id }}</div>

      <div class="text-gray-500">Date</div>
      <div class="font-semibold text-gray-800">
        {{ ordesDeails?.createdAt | date: "dd MMM yyyy" }}
      </div>

      <div class="text-gray-500">Total</div>
      <div class="font-semibold text-gray-800">
        <!-- Rs. {{ ordesDeails?.payment_gateway === 'prepaid' 
         ? ordesDeails?.total_amount - 35
         : ordesDeails?.total_amount }} -->

        <div class="font-semibold text-gray-800">
          ₹
          {{
            (ordesDeails?.payment_gateway === "prepaid"
              ? ordesDeails?.total_amount - 35
              : ordesDeails?.total_amount) + (ordesDeails?.coupon_amount || 0)
          }}
        </div>
      </div>

      <div class="text-gray-500">Payment Method</div>
      <div class="font-semibold text-gray-800">
        {{ ordesDeails.payment_gateway }}
      </div>
    </div>

    <!-- Product Details -->
    <h3 class="text-xl font-semibold">Order Summary</h3>
    <div class="space-y-4">
      <!-- Product Item -->
      <div
        class="flex flex-wrap items-center gap-3 border-b pb-4 sm:flex-nowrap sm:gap-4"
        *ngFor="let item of ordesDeails?.items"
      >
        <img
          [src]="orderListDetailsImageUrl + item?.displayImage"
          [alt]="item?.name || item?.product_id?.name || 'Product image'"
          class="w-16 h-16 rounded-lg object-cover"
        />
        <div class="min-w-0 flex-1">
          <h4 class="font-semibold text-gray-800">{{ item?.name }}</h4>
          <!-- <p class="text-sm dark:text-white leading-none text-black text-lg font-normal">Free</p> -->
          <p
            class="text-sm dark:text-white leading-none text-black text-lg font-normal"
          >
            {{ item?.quantity }}
          </p>
          <p class="text-gray-500">{{ item?._id }}</p>
        </div>

        <div class="font-semibold text-black">
          Rs.
          {{
            ordesDeails?.payment_gateway === "prepaid"
              ? item?.price - 35
              : item?.price
          }}
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="mt-6 flex flex-col items-stretch gap-4 sm:flex-row sm:items-center sm:justify-between">
      <a href="/" class="text-purple-600 font-semibold hover:underline"
        >Continue Shopping</a
      >
      <button
        class="bg-purple-600 text-white px-6 py-3 rounded-lg hover:bg-purple-700 transition"
        (click)="gotoTrackingOrder()"
      >
        Track Order
      </button>
    </div>
  </div>
</div>
